import React, { useEffect, useState } from 'react';
import { Col, Row, Button } from 'react-bootstrap';
import { PencilSquare } from 'react-bootstrap-icons';
import { cloneDeep, sortBy } from 'lodash';

import { ApiServiceServerless } from '../../xhr_libs';
import EnergyTracerTable, {
  AddEntityFilterHeader,
} from '../../components/tables';
import { textFilterIncludes } from '../../components/tables/filters';
import { linkFormatter } from '../../components/tables/formatters';
import LicenseCell from './LicenseCell';
import AdminLicenseModal from '../../components/modals/AdminLicenseModal';
import Loader from '../../components/Loader';

const styles = {
  row: { marginTop: '1em', marginBottom: '1em' },
};

export default function AdminLicenses() {
  const [licenses, setLicenses] = useState([]);
  const [currentLicense, setCurrentLicense] = useState({
    id: 0,
    name: 'none',
    has_billing_contact: false,
    licenses: {},
  });

  const [isLoading, setIsLoading] = useState(false);

  const [showLicenseModal, setShowLicenseModal] = useState(false);

  useEffect(() => {
    setIsLoading(true);
    ApiServiceServerless.get('/licenses')
      .then(({ data }) => {
        setLicenses(data);
        setIsLoading(false);
      })
      .catch((err) => {
        setIsLoading(false);
        throw err;
      });
  }, []);

  const licenseTableSetter = (id, type, expiration, status) => {
    setLicenses((prev) =>
      prev.map((org) => {
        if (org['id'] !== id) return org;
        let newOrg = cloneDeep(org);
        newOrg['licenses'][type]['expiration'] = expiration;
        newOrg['licenses'][type]['status'] = status;
        return newOrg;
      })
    );
  };

  const LICENSE_COLUMNS = [
    {
      dataField: 'name',
      text: 'Organization',
      filter: textFilterIncludes('Organization', 'name'),
      formatter: linkFormatter((row) => [`/organizations/${row.id}`, row.name]),
      filterRenderer: (onFilter) => (
        <AddEntityFilterHeader
          onFilter={onFilter}
          filterText='Filter Organization'
        />
      ),
    },
    {
      dataField: 'license1',
      formatter: (_cell, row) => (
        <LicenseCell
          status={row['licenses']['analysis']['status']}
          expiration={row['licenses']['analysis']['expiration']}
        />
      ),
      text: 'Analysis',
    },
    {
      dataField: 'license2',
      formatter: (_cell, row) => (
        <LicenseCell
          status={row['licenses']['urjanet']['status']}
          expiration={row['licenses']['urjanet']['expiration']}
        />
      ),
      text: 'Urjanet',
    },
    {
      dataField: 'license3',
      formatter: (_cell, row) => (
        <LicenseCell
          status={row['licenses']['plug']['status']}
          expiration={row['licenses']['plug']['expiration']}
        />
      ),
      text: 'Plug',
    },
    {
      dataField: 'license4',
      formatter: (_cell, row) => (
        <LicenseCell
          status={row['licenses']['ghg']['status']}
          expiration={row['licenses']['ghg']['expiration']}
        />
      ),
      text: 'GHG',
    },
    {
      dataField: 'actions',
      formatter: (_cell, row) => (
        <Button
          variant='link'
          onClick={(e) => {
            setCurrentLicense(row);
            setShowLicenseModal(true);
          }}
        >
          <PencilSquare />
        </Button>
      ),
      text: 'Actions',
    },
  ];

  return (
    <>
      {isLoading ? (
        <Loader />
      ) : (
        <>
          <Row style={styles.row}>
            <Col md={12}>
              <Row>
                <Col xs={1} lg={1} />
                <Col xs={10} lg={10}>
                  <EnergyTracerTable
                    data={sortBy(licenses, ['name'])}
                    columns={LICENSE_COLUMNS}
                    keyField='id'
                    enablePaging={true}
                    enableFilter={true}
                  />
                </Col>
                <Col xs={1} lg={1} />
              </Row>
            </Col>
          </Row>
          <AdminLicenseModal
            show={showLicenseModal}
            onHide={() => setShowLicenseModal(false)}
            currentLicense={currentLicense}
            licenseTableSetter={licenseTableSetter}
          />
        </>
      )}
    </>
  );
}
